import { message } from "antd";
import { IMenuOption, ISwimlaneInvoiceList, ISwimlaneMaster } from "models/interfaces";
import React from "react";
import { PurchaseAndShippingService } from "services/SkyboxServices";
import { LoggerService } from "sharedServices";

const target_swimlane_id = 6;

const MoveToDeliveredShipping: React.FC<{
  menuData: IMenuOption
  swimlaneData: ISwimlaneMaster;
  eachInvoiceData: ISwimlaneInvoiceList;
  setShowMenu: Function;
  setSelectedMenuId: Function;
  requestToReloadTheLanes: Function;
}> = ({
  menuData,
  swimlaneData,
  eachInvoiceData,
  setShowMenu,
  setSelectedMenuId,
  requestToReloadTheLanes
}) => {
  const moveToDelivered = async () =>{
    const moveToDeliveredKey = "moveToDeliveredKey";
    setSelectedMenuId(null);
    setShowMenu(false);

    message.loading({
      content: `Moving Invoice from ${swimlaneData.name} to Delivered / Complete queue...`,
      duration: 0,
      key: moveToDeliveredKey,
      className: "toastMsg loadingMsg",
    });
    try {
      await new PurchaseAndShippingService()
        .markAsDeliveredShipping({
          invoice_id: eachInvoiceData.invoice_id,
          swimlane_id: target_swimlane_id
        });
        requestToReloadTheLanes([swimlaneData.id, target_swimlane_id]);

        message.success({
          content: `Invoice #${eachInvoiceData.invoice_id} moved from ${swimlaneData.name} to Delivered / Complete Queue.`,
          duration: 5,
          key: moveToDeliveredKey,
          className: "toastMsg savedSuccess",
        });
    } catch (error: any) {
      message.error({
        key: moveToDeliveredKey,
        content: "Failed to update.",
        duration: 5,
        className: "toastMsg savedFailed",
      });

      new LoggerService().log({
        payload: error,
        function_name: "moveToDelivered",
      });
    }

    setTimeout(() => {
      requestToReloadTheLanes(null);
    }, 500);
  }

  return (
    <React.Fragment>
      <div className="accHead" onClick={moveToDelivered}>{menuData.name}</div>
    </React.Fragment>
  );
};

export default MoveToDeliveredShipping;
